import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  ChangeDetectionStrategy,
  EventEmitter,
} from '@angular/core';
import { IContactCard } from './contact-card.model';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';

@Component({
  selector: 'app-contact-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  providers: [TranslateService, TranslatePipe],
  templateUrl: './contact-card.component.html',
  styleUrl: './contact-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactCardComponent {
  @Input() contactCards: Array<IContactCard> = [];
  @Input() totalcount: number;
  @Output() onPaginateEvent = new EventEmitter<number>();
  itemsPerPage: number = 2;
  currentPage: number = 1;
  totalPages: number = 1;

  constructor() {
    this.paginate();
  }

  paginate(): void {
    this.totalPages = Math.ceil(this.totalcount / this.itemsPerPage);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    this.onPaginateEvent.emit(startIndex);
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.paginate();
  }

  get totalPagesArray(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }
}
